






































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue'
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import MultipleLineText from '@/components/common/elements/MultipleLineText.vue'
import Button from '@/components/common/elements/Button.vue';

@Component({
  components: {
    InputNoVModel,
    SelectNoVModel,
    MasterSelectMultiSetControl,
    MultipleLineText,
    Button
  },
})
export default class MainCreditInfomationTab extends Vue {
  inheritAttrs = false;
  
  @Prop({ default: () => ({}) })
  private item: any;

  /**
   * 親コンポーネントに入力値を通知する
   * @param data - 入力値
   * @param index - 入力行番号
   */
  @Emit('inputOperation')
  public inputOperation(data: any, index?: number) {
    // this.reflectInputValue(index, data.name, data.value);
    this.emit({ data, index });
  }

  /**
   * 親コンポーネントに選択値を通知する
   * @param data - 入力値
   * @param index - 入力行番号
   */
  @Emit('changeSelect')
  public changeSelect(data: { [k: string]: any }, index?: number) {
    // this.reflectInputValue(index, data.name, data.value.value);
    this.emit({ data, index });
  }

  /**
   * 入力値を反映する
   */
  private reflectInputValue(listIndex: number, targetName: string, reflectValue: any) {
    if (listIndex) {
      this.item.listDatas[listIndex][targetName] = reflectValue;
    } else {
      this.item[targetName] = reflectValue;
    }
  }

  @Emit('tabChildrenEventRelay')
  private emit(response: any) {
    return response;
  }
}
